const OPEN_CLASS = 'is-open'

export class Toggle {
  /**
   * Create new toggle
   * @param {HTMLButtonElement} button Toggle button
   */
  constructor (button) {
    this.id = button.getAttribute('aria-controls')

    this.button = button
    this.children = document.querySelector(`#${this.id}`)

    this.isOpen = button.getAttribute('aria-expanded') === 'true'
  }

  init () {
    this.button.addEventListener('click', () => this.toggle())
  }

  open () {
    this.children.classList.add(OPEN_CLASS)
    this.button.setAttribute('aria-expanded', true)
    this.isOpen = true
  }

  close () {
    this.children.classList.remove(OPEN_CLASS)
    this.button.setAttribute('aria-expanded', false)
    this.isOpen = false
  }

  toggle () {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
}
